import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "recommend-list" }
const _hoisted_2 = { class: "title flex items-center justify-between mt-[32px] mb-[16px]" }
const _hoisted_3 = { class: "imageList" }
const _hoisted_4 = {
  key: 0,
  class: "title flex items-center justify-between mb-[16px]"
}
const _hoisted_5 = { class: "text-ellipsis whitespace-nowrap overflow-hidden font-bold" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "imageList mb-[32px]"
}

import elementItem from './elementItem.vue'
import { ElSkeleton, ElSkeletonItem } from 'element-plus'
import { getMaterialsRecommendations } from '@/api/affairs'
import { onMounted, ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'recommendSection',
  props: {
    searchkwords: {}
  },
  emits: ['more', 'num'],
  setup(__props: any, { emit: __emit }) {

// @ts-ignore
const emit = __emit
const props = __props
onMounted(() => {
  getList()
})

const list = ref([])
const loading = ref(true)

const getList = () => {
  getMaterialsRecommendations({ page: 1, size: 100, type: 1, name: props.searchkwords }).then(res => {
    list.value = res.data.data.items
    emit('num', list.value)
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
          return _createElementVNode("div", {
            key: 'sk-' + n
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElSkeleton), { animated: "" }, {
                template: _withCtx(() => [
                  _createVNode(_unref(ElSkeletonItem), {
                    variant: "text",
                    class: "skeleton-title"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "w-[33%] h-[80px] rounded-md overflow-hidden"
                }, [
                  _createVNode(_unref(ElSkeleton), { animated: "" }, {
                    template: _withCtx(() => [
                      _createVNode(_unref(ElSkeletonItem), {
                        variant: "image",
                        class: "skeleton-img"
                      })
                    ]),
                    _: 1
                  })
                ])
              }), 64))
            ])
          ])
        }), 64))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(list.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            (item.materials.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: "more cursor-pointer",
                    onClick: ($event: any) => (emit('more', item))
                  }, " 更多", 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true),
            (item.materials.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.materials.slice(0, 3), (img, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "w-[33%] h-[90px] rounded-md overflow-hidden"
                    }, [
                      _createVNode(elementItem, { template: img }, null, 8, ["template"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
  ]))
}
}

})